import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {RolePermission } from '../shared/models/role.permission.enum';
import { AuthService } from '../shared/services/auth.service';
import { BaseService } from '../shared/services/base.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent extends AbstractBiditComponent implements OnInit, OnDestroy {

  private usernameSubscription: Subscription;

  username: string;
  isIDIAdmin: boolean = false;
  isDealerAdmin: boolean = false;
  isFieldTech: boolean = false;

  canAddLead: boolean = false;
  canAddQuote: boolean = false;
  canAddCustomer: boolean = false;
  quoteOnly: boolean;

  constructor(private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    this.usernameSubscription = AuthService.authNavStatus$.subscribe(authenticated => {
      this.username = "";
      if (authenticated) {
        setTimeout(() => {
          let user = AuthService._authUserSource.value;

          this.username = user.firstName;
          this.quoteOnly = user.isQuoteOnly;

          this.isIDIAdmin = authenticated == 'IDI';
          this.isDealerAdmin = BaseService.hasPermission(RolePermission.Admin) && authenticated == 'Dealer';
          this.isFieldTech = BaseService.hasPermission(RolePermission.FieldTechnician);

          this.canAddLead = BaseService.hasPermission(RolePermission.AddLead);
          this.canAddQuote = BaseService.hasPermission(RolePermission.AddQuote);
          this.canAddCustomer = BaseService.hasPermission(RolePermission.AddCustomer);
        });
      }
    });
  }

  ngOnDestroy() {
    this.usernameSubscription.unsubscribe();
  }

  get hideJobTools(): boolean {
    return this.isIDIAdmin || this.quoteOnly;
  }

}
